import styled from '@emotion/styled';

import {Message} from "@britishcouncil/react-extro-ui";

export const Form = styled.form`
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 1px 4px 0px rgba(84, 86, 90, 0.24);
    padding: 16px;

    & > .form-group {
        margin-bottom: 24px;
    }

    .form-group > label::after {
        content: '*';
        color: red;
        margin-left: 5px;
    }
`;

export const ButtonContainer = styled.div`
  border-top: 1px solid #c1c1c1;
  padding-top: 24px;
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;

  .btn {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const SummaryContainer = styled.div`
    width: 100%;
    
    .item-row {
        display: flex;
        justify-content: space-between;
    }

    .item-row + .item-row {
        padding-top: 8px;
    }
    
    .item-name {
        text-align: left;
    }

    .item-price {
        text-align: right;
    }

    .total-row {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-weight: bold;
    }
    
    .total-price {
        text-align: right;
    }
`;

export const StyledMessage = styled(Message)`
    margin-bottom: 20px;
`;
